export default [
  {
    title: 'breadcrumb.company',
    route: 'list-company',
    icon: 'UserIcon',
    resource: 'company',
    action: 'read'
  }
];